import type { LocationsMapSearch } from '~/types';
import { BaseModel } from '~/models/base-model';

export class LocationsMapSearchModel extends BaseModel<LocationsMapSearch> {
    radius = 20;
    unit = 'mi';
    location = '';
    geolocation = null;
}
